module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/openweather-weathercodes/01n-9ed9031b8fd64da63790aab749eedfa9.svg";